import { render, staticRenderFns } from "./volume-action-menu.vue?vue&type=template&id=7912d53a&scoped=true&"
import script from "./volume-action-menu.vue?vue&type=script&lang=js&"
export * from "./volume-action-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912d53a",
  null
  
)

export default component.exports